import clone from 'lodash.clonedeep';
import {
  ALL_GRADING_EXCLUSIONS,
  CONDITION_OPTIONS,
  GRADING_COMPANIES,
  QUERY_KEYWORDS,
} from '../constants';

export const getSuggestedQuery = (card) => {
  if (!card.player || !card.category || !card.condition || !card.year) {
    return '';
  }

  const baseQuery = buildQueryInclusions(card);

  const exclusionQuery = buildQueryExclusions(card, baseQuery.toLowerCase());

  return `${baseQuery} ${exclusionQuery}`;
};

export const getGradeExclusions = (conditions) => {
  const gradeExclusions = [];
  const conditionExclusions = [];
  const conditionObjects = conditions.map((condition) => CONDITION_OPTIONS.find(({ value }) => value === condition));

  conditionObjects.forEach((conditionObject) => {
    if (conditionObject && conditionObject.exclusions) {
      conditionExclusions.push(...conditionObject.exclusions);
    }
  });

  gradeExclusions.push(...new Set(conditionExclusions
    .filter((exclusion) => {
      return !conditionObjects.map(({ value }) => value.toLowerCase()).includes(exclusion.toLowerCase());
    })));

  const companyExclusions = [];

  const conditionCompanies = [...new Set(conditions
    .map((condition) => {
      const conditionCompany = getGradingCompany(condition);
      return GRADING_COMPANIES.find(({ value }) => conditionCompany === value);
    }))];

  conditionCompanies.forEach((company) => {
    if (company && company.exclusions) {
      companyExclusions.push(...company.exclusions);
    }
  });

  gradeExclusions.push(...new Set(companyExclusions
    .filter((exclusion) => {
      const companyNames = [];

      conditionCompanies.forEach((conditionCompany) => {
        if (conditionCompany) {
          const { value, altNames } = conditionCompany;
          companyNames.push(value.toLowerCase(), ...altNames.map((name) => name.toLowerCase()));
        }
      });

      return !companyNames.includes(exclusion.toLowerCase());
    })));

  ALL_GRADING_EXCLUSIONS.forEach((value) => {
    gradeExclusions.push(value);
  });

  conditions.forEach((condition) => {
    const conditionCompany = getGradingCompany(condition);
    const gradingCompanyObject = GRADING_COMPANIES.find(({ value }) => conditionCompany === value);
    const conditionIndex = CONDITION_OPTIONS.findIndex(({ value }) => value === condition);
    const conditionObject = CONDITION_OPTIONS.find(({ value }) => value === condition);

    CONDITION_OPTIONS
      .filter(({ gradingCompany }, index) => gradingCompany && gradingCompanyObject && gradingCompanyObject.value === gradingCompany && (conditionObject.queryValue === undefined || condition.queryValue !== '') && index > conditionIndex)
      .filter(({ value }) => !`${condition} `.includes(`${value} `) && !value.includes('/') && !value.includes('Black') && !value.includes('Pristine') && !value.includes('Authentic') && !value.includes('Perfect'))
      .forEach(({ value }) => {
        if (!conditions.map((condition) => condition.toLowerCase()).includes(value.toLowerCase())) {
          gradeExclusions.push(value);
        }
      });
  });

  return [...new Set(gradeExclusions)];
};

export const getGradingCompany = (condition) => {
  const gradingCompanyObject = CONDITION_OPTIONS.find(({ value }) => condition === value);

  if (!gradingCompanyObject) return null;

  return gradingCompanyObject.gradingCompany || null;
};

export const replaceGradeInQuery = (query, newCondition) => {
  if (!query) {
    return '';
  }

  let updatedQuery = clone(query);

  CONDITION_OPTIONS.forEach((conditionOption) => {
    updatedQuery = updatedQuery.replace(` -(${conditionOption.value})`, '');
    updatedQuery = updatedQuery.replace(` ${conditionOption.value}`, '');

    if (conditionOption.queryValue) {
      updatedQuery = updatedQuery.replace(` -(${conditionOption.queryValue})`, '');
      updatedQuery = updatedQuery.replace(` ${conditionOption.queryValue}`, '');
    }

    if (conditionOption.exclusions) {
      conditionOption.exclusions.forEach((exclusion) => {
        updatedQuery = updatedQuery.replace(` -(${exclusion})`, '');
        updatedQuery = updatedQuery.replace(` -${exclusion}`, '');
      });
    }
  });

  GRADING_COMPANIES.forEach((gradingCompanyObject) => {
    gradingCompanyObject.exclusions.forEach((value) => {
      updatedQuery = updatedQuery.replace(` -(${value})`, '');
      updatedQuery = updatedQuery.replace(` -${value}`, '');
    });

    updatedQuery = updatedQuery.replace(` -(${gradingCompanyObject.label})`, '');
    updatedQuery = updatedQuery.replace(` -${gradingCompanyObject.label}`, '');
  });

  ALL_GRADING_EXCLUSIONS.forEach((exclusion) => {
    updatedQuery = updatedQuery.replace(` -${exclusion}`, '');
  });

  const newConditionObject = CONDITION_OPTIONS.find(({ value }) => value === newCondition);
  const insertionIndex = updatedQuery.indexOf(' -') > -1 ? updatedQuery.indexOf(' -') : updatedQuery.length;

  let conditionString = `${newConditionObject.queryValue !== undefined ? newConditionObject.queryValue : newCondition}`;

  const gradeExclusions = getGradeExclusions([newCondition]);

  gradeExclusions.forEach((value) => {
    conditionString += /\s/g.test(value) ? ` -(${value})` : ` -${value}`;
  });

  updatedQuery = updatedQuery.slice(0, insertionIndex) + ` ${conditionString} ` + updatedQuery.slice(insertionIndex);
  updatedQuery = updatedQuery.replace(/ +(?= )/g, '');

  return updatedQuery;
};

export const buildQueryInclusions = (card) => {
  let year = card.year;

  const inclusions = [year, card.player];

  if (card.condition) {
    const condition = CONDITION_OPTIONS.find(({ value }) => value === card.condition);

    let conditionQuery = condition.queryValue !== undefined ? condition.queryValue : card.condition;

    if (conditionQuery) {
      inclusions.push(conditionQuery);
    }
  }

  if (!inclusions.join('')) return '';

  return inclusions.join(' ').replace(/-/g, '');
};

export const buildQueryExclusions = (card, baseQuery) => {
  const exclusions = [];

  QUERY_KEYWORDS.all.forEach((item) => {
    if (!baseQuery.includes(item.toLowerCase())) {
      exclusions.push(item);
    }
  });

  if (QUERY_KEYWORDS[card.category]) {
    const categoryExclusions = QUERY_KEYWORDS[card.category];

    if (categoryExclusions) {
      categoryExclusions.forEach((item) => {
        if (!baseQuery.includes(item.toLowerCase())) {
          exclusions.push(item);
        }
      });
    }
  }
  return [...getGradeExclusions([card.condition]), ...exclusions]
    .map((item) => /\s/g.test(item) ? `-(${item})` : `-${item}`)
    .join(' ');
};
